export default function FlightAnimation(item, startPos, duration = 50) {
  const scale = 2;
  let count = 0;
  startPos.x = startPos.x / scale - item.sprite.width / 2;
  startPos.y = startPos.y / scale - item.sprite.height / 4;
  function tick(p) {
    const target = {
      x: p.width / scale,
      y: 0
    };
    const diff = {
      x: (target.x - startPos.x) / duration,
      y: (target.y - startPos.y) / duration
    };
    const factor = Math.pow(1.25, count);
    const newPos = {
      x: startPos.x + factor * diff.x,
      y: startPos.y + factor * diff.y
    };
    const {
      sprite
    } = item;
    p.push();
    p.scale(scale);
    p.image(sprite, newPos.x, newPos.y);
    p.pop();
    count++;
    return count < duration;
  }
  return {
    tick
  };
}